import {
  createFileRoute,
  useCanGoBack,
  useRouter,
} from "@tanstack/react-router";

import { useProcurementRuntime } from "../runtime/procurement-runtime";
import { DemandAssignment } from "../screens/demand-assignment";
import {
  destinationByPath,
  ProcurementDestinationRoute,
} from "../screens/procurement-shell";

export const Route = createFileRoute("/demand-assignment")({
  validateSearch: (search: Record<string, unknown>): { origin?: string } =>
    typeof search.origin === "string" && search.origin
      ? { origin: search.origin }
      : {},
  component: DemandAssignmentRoute,
});

function DemandAssignmentRoute() {
  const { catalog, demands } = useProcurementRuntime();
  const { origin } = Route.useSearch();
  const navigate = Route.useNavigate();
  const router = useRouter();
  const canGoBack = useCanGoBack();
  return (
    <ProcurementDestinationRoute
      destination={destinationByPath["/demand-assignment"]}
    >
      <DemandAssignment
        catalog={catalog}
        demands={demands}
        originID={origin ?? ""}
        onAssigned={() => {
          if (canGoBack) router.history.back({ ignoreBlocker: true });
        }}
        onOpenGroup={(ID) =>
          void navigate({ to: "/demand-groups", search: { group: ID } })
        }
        onOriginChange={(ID) =>
          void navigate({ search: { origin: ID }, replace: true })
        }
      />
    </ProcurementDestinationRoute>
  );
}
